var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#006AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10C10.8954 10 9.99999 10.8955 9.99999 12C9.99999 13.1046 10.8954 14 12 14Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 12C6.55878 8.83715 9.08389 6.66669 12 6.66669C14.9161 6.66669 17.4412 8.83715 18.6667 12C17.4412 15.1629 14.9161 17.3334 12 17.3334C9.08389 17.3334 6.55878 15.1629 5.33333 12ZM15.3333 12C15.3333 13.841 13.8409 15.3334 12 15.3334C10.159 15.3334 8.66666 13.841 8.66666 12C8.66666 10.1591 10.159 8.66669 12 8.66669C13.8409 8.66669 15.3333 10.1591 15.3333 12Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOtp);
export default __webpack_public_path__ + "static/media/ViewOTP.bad5793b357bfdf8003159a0107b6402.svg";
export { ForwardRef as ReactComponent };